import $ from 'jquery';

$(function () {

    $('.opening-acc__header').on('click', function() {
       $(this).siblings('.opening-acc__body').slideToggle();
       $(this).parent().toggleClass('active');
    });

});